import React, { useState } from 'react';

import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
import DashboardCard15grup from '../../partials/dashboard/DashboardCard15grup';
import DashboardCard15 from '../../partials/dashboard/DashboardCard15';
import { useNavigate } from "react-router-dom";


function Producers() {

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();

    const handleNewRows = (item) => {
        //////////////////////////////console.log(item);
    
       navigate("/createuser");
      };

    return (
        <div className="flex h-screen overflow-hidden">

            {/* Sidebar */}
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            {/* Content area */}
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                {/*  Site header */}
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        <div className="w-full grid grid-cols-12 gap-4 justify-center">
                            <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6 w-full">
                            <DashboardCard15 />
                            </div>

                            <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6 w-full xs:pb-10">
                            <DashboardCard15grup/>
                            </div>
                        </div>

                    </div>
                </main>


            </div>
        </div>
    );
}

export default Producers;